module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3n1hg"))).then(() => parcelRequire('3a9aZ'));